export default "__VITE_ASSET__e415c826__"